import { useState } from "react";
import CheckPriceComponent from "../components/check-price/CheckPriceComponent";
import { additionalPrice } from "../utils/helperFunction";

import "../components/check-price/call-for-price-style.scss";
export default function CallForPrice() {
  const [dataCheckPrice, setDataCheckPrice] = useState({
    additionalPrice: additionalPrice.sort((a, b) => {
      return a?.priority - b?.priority;
    }),
  });
  const [priceCheckPrice, setPriceCheckPrice] = useState(-1);
  const reset = () => {
    setDataCheckPrice({
      additionalPrice: additionalPrice,
    });
    setPriceCheckPrice(-1);
  };

  const changeDataCheckPriceFun = (object, type = "normal", id = 0) => {
    if (type == "normal") {
      setDataCheckPrice((prev) => {
        return { ...prev, ...object };
      });
    } else if (type == "checkbox") {
      let arrayCheckTemp = dataCheckPrice?.additionalPrice?.map((v) => {
        if (v.id == id) {
          return { ...v, checked: !v.checked };
        } else return v;
      });

      setDataCheckPrice((prev) => {
        return { ...prev, additionalPrice: arrayCheckTemp };
      });
    } else if (type == "countCheckbox") {
      let arrayCheckTemp = dataCheckPrice.additionalPrice.map((v) => {
        if (v.id == id) {
          return { ...v, ...object };
        } else return v;
      });
      setDataCheckPrice((prev) => {
        return { ...prev, additionalPrice: arrayCheckTemp };
      });
    }
  };
  return (
    <div
      className="pt-3 call-for-price-style"
      style={{ backgroundColor: "aliceblue", height: "auto" }}
    >
      <div className="d-flex">
        <h5
          className="font-bold p-3 mx-auto text-center rounded-top"
          style={{ backgroundColor: "white", width: 200 }}
        >
          استعلام قیمت
        </h5>
      </div>

      <div
        style={{ backgroundColor: "white", borderRadius: 10 }}
        className=" col-11 col-md-9 mx-auto "
      >
        <CheckPriceComponent
          data={dataCheckPrice}
          changeData={changeDataCheckPriceFun}
          price={priceCheckPrice}
          setPrice={setPriceCheckPrice}
          reset={reset}
        />
      </div>
    </div>
  );
}
